import React from 'react';

/**
 * Floating WhatsApp button — visible across all pages (public + logged-in).
 * Mobile-friendly (touch target ≥ 48x48), accessible (aria-label + tooltip).
 */
const WHATSAPP_NUMBER = '5521972207886';
const PREFILLED_MESSAGE =
  'Olá! Vim pelo site do Akali AI Consultant e tenho uma dúvida sobre a ferramenta.';

const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(PREFILLED_MESSAGE)}`;

export const WhatsAppFloatingButton = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale com a gente no WhatsApp"
      title="Fale com a gente no WhatsApp"
      data-testid="whatsapp-float-btn"
      className="group fixed bottom-[88px] right-4 md:bottom-5 md:right-5 z-40 flex items-center"
    >
      {/* Tooltip */}
      <span
        className="
          mr-3 hidden md:inline-block
          rounded-lg bg-slate-900 px-3 py-1.5 text-xs font-medium text-white shadow-lg
          opacity-0 -translate-x-1 transition-all duration-200
          group-hover:opacity-100 group-hover:translate-x-0
          dark:bg-slate-700
        "
      >
        Fale com a gente no WhatsApp
      </span>

      {/* Button */}
      <span
        className="
          relative flex h-14 w-14 items-center justify-center
          rounded-full shadow-xl
          transition-transform duration-200 hover:scale-110 active:scale-95
        "
        style={{ backgroundColor: '#25D366' }}
      >
        {/* Subtle pulse halo (every 10s) */}
        <span
          className="absolute inline-flex h-full w-full rounded-full"
          style={{
            backgroundColor: '#25D366',
            animation: 'akaliWaPulse 10s cubic-bezier(0.4, 0, 0.6, 1) infinite',
            opacity: 0.55,
          }}
          aria-hidden="true"
        />

        {/* WhatsApp glyph (official) */}
        <svg
          viewBox="0 0 32 32"
          width="28"
          height="28"
          fill="white"
          aria-hidden="true"
          className="relative z-10"
        >
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.063 0-.125-.018-.183-.054-.347-.215-2.22-1.097-3.13-2.18-.21-.25-.63-.713-.63-.999 0-.214.116-.295.21-.36.36-.244.96-.63 1.066-1.146.018-.085.018-.176.001-.262-.097-.5-1.046-2.486-1.236-2.6-.094-.057-.205-.099-.323-.099h-.6c-.063 0-.18.018-.275.054-.84.336-1.282 1.156-1.282 2.13 0 1.65 1.107 3.165 1.59 3.764 1.193 1.49 2.81 2.71 4.587 3.42 1.39.55 2.108.633 2.78.51.42-.073 1.282-.524 1.464-1.03.18-.503.18-.93.126-1.022-.054-.09-.198-.14-.42-.245-.222-.105-1.281-.633-1.481-.704-.2-.07-.345-.105-.49.106-.144.21-.567.704-.69.84-.13.142-.262.155-.485.05zM16 4C9.373 4 4 9.373 4 16c0 2.13.553 4.18 1.604 5.997L4 28l6.13-1.6A11.964 11.964 0 0 0 16 28c6.627 0 12-5.373 12-12S22.627 4 16 4zm0 21.6c-1.71 0-3.388-.45-4.857-1.298l-.348-.205-3.612.94.96-3.527-.227-.36A9.595 9.595 0 0 1 6.4 16c0-5.302 4.298-9.6 9.6-9.6s9.6 4.298 9.6 9.6-4.298 9.6-9.6 9.6z" />
        </svg>
      </span>

      {/* Inline keyframes — subtle pulse 1x/10s */}
      <style>{`
        @keyframes akaliWaPulse {
          0%, 90%, 100% { transform: scale(1); opacity: 0; }
          93% { transform: scale(1); opacity: 0.55; }
          97% { transform: scale(1.45); opacity: 0; }
        }
      `}</style>
    </a>
  );
};

export default WhatsAppFloatingButton;
